import { NgModule } from '@angular/core';
import { TranslationKeyExtractPipe } from './translation-key-extract.pipe';

@NgModule({
    declarations: [TranslationKeyExtractPipe],
    exports: [TranslationKeyExtractPipe]
})
export class TranslationKeyExtractModule {}
